module.exports = __webpack_public_path__ + "static/showreel-cover-86742ed530676b128a3b44baddf51008.jpg";